import React from 'react'

import { Badge } from 'reactstrap'

import { defaultDateFormat, formatDateByLanguage } from 'utils/formatters'
import Button from 'common/Button'
import Icon from 'common/Icon'
import PdfExternalLink from 'common/PdfExternalLink'

import { TableListStatus, TableListStatusItem } from 'components/Case/CaseDetail/TableList'

export default ({ resource, proposeItem, language }) => {


    // const { status, proposals = [] } = proposeItem

    const { status = [] } = proposeItem
    const proposal = proposeItem.proposals



    return (
        <TableListStatus>
            {status.bundleSent && (
                <React.Fragment>
                    <TableListStatusItem>
                        <div className="d-flex align-items-center">
                            <Badge color="success">
                                <Icon icon="done" className="md-14" />
                            </Badge>
                            <div className="ms-2">{resource.BundleSent}</div>
                            {proposal.map((item, index) => (

                                <PdfExternalLink
                                    key={item.pdfFileId}
                                    fileId={item.pdfFileId}
                                    fileName={item.documentNumber}
                                    title={`${resource.DownloadProposal} ${index + 1} ${resource.AsPDF}`}
                                    className="ms-2"
                                    fileUrl={item.pdfFileUrl}

                                />
                            ))}
                        </div>
                        <small className="text-muted">
                            <em>{formatDateByLanguage(status.dateBundleSent, defaultDateFormat, language)}</em>
                        </small>
                    </TableListStatusItem>
                    <TableListStatusItem>
                        {status.proposalSelected && (
                            <React.Fragment>
                                <div className="d-flex align-items-center">
                                    <Badge color="success">
                                        <Icon icon="done" className="md-14" />
                                    </Badge>
                                    <div className="ms-2 me-1">{resource.ProposalSelected}</div>
                                </div>
                                <small className="text-muted">
                                    <em>{formatDateByLanguage(status.dateProposalSelected, defaultDateFormat, language)}</em>
                                </small>
                            </React.Fragment>
                        )}
                        {!status.proposalSelected && (
                            <React.Fragment>
                                <div className="d-flex align-items-center">
                                    <Badge color="danger">
                                        <Icon icon="clear" className="md-14" />
                                    </Badge>
                                    {(status.bundleRevoked || status.bundleRejected) ? (
                                        <div className="ms-2 me-1 del">
                                            <del>{resource.ProposalSelected}</del>
                                        </div>
                                    ) : (
                                        <div className="ms-2 me-1 del">
                                            {resource.ProposalSelected}
                                        </div>
                                    )}
                                </div>
                                {status.bundleRevoked && (
                                    <small className="text-muted">
                                        <em>{formatDateByLanguage(status.dateBundleRevoked, defaultDateFormat, language)}</em>
                                    </small>
                                )}
                                {status.bundleRejected && (
                                    <small className="text-muted">
                                        <em>{formatDateByLanguage(status.dateBundleRejected, defaultDateFormat, language)}</em>
                                    </small>
                                )}
                            </React.Fragment>
                        )}
                    </TableListStatusItem>
                </React.Fragment>
            )}
            {!status.bundleSent && (
                <React.Fragment>
                    <TableListStatusItem>
                        <div className="d-flex align-items-center">
                            <Badge color="danger">
                                <Icon icon="clear" className="md-14" />
                            </Badge>
                            <div className="ms-2 me-1">{resource.BundleSent}</div>
                        </div>
                        <Button color="primary" size="sm" className="text-lowercase">
                            {resource.SendNow}
                        </Button>
                    </TableListStatusItem>
                    <TableListStatusItem>
                        <div className="d-flex align-items-center">
                            <Badge color="danger">
                                <Icon icon="clear" className="md-14" />
                            </Badge>
                            <div className="ms-2 me-1">{resource.ProposalSelected}</div>
                        </div>
                    </TableListStatusItem>
                </React.Fragment>
            )}
        </TableListStatus>
    )
}
